module.exports = __webpack_public_path__ + "img/fps.675e3f51.png";